module.exports = __webpack_public_path__ + "static/media/gameweek-winner.5fbf64d7.png";